function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinceCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 87.03125 32.671875 C 86.671875 32.578125 72.359375 58.230469 68.128906 57.238281 C 63.71875 56.160156 68.941406 23.398438 68.851562 23.398438 C 68.578125 23.308594 58.5 53.191406 54.089844 52.828125 C 49.859375 52.378906 45.449219 14.941406 45 14.941406 C 44.550781 14.941406 40.140625 52.378906 35.910156 52.828125 C 31.5 53.191406 21.421875 23.308594 21.148438 23.398438 C 21.058594 23.398438 25.921875 54.179688 21.328125 55.261719 C 16.921875 56.25 3.328125 32.578125 2.96875 32.671875 C 7.46875 44.550781 12.058594 56.519531 16.558594 68.398438 C 34.921875 62.101562 55.078125 62.101562 73.441406 68.398438 C 77.941406 56.519531 82.53125 44.550781 87.03125 32.671875 Z M 87.03125 32.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.078125 75.058594 C 23.21875 73.621094 27.539062 72.539062 31.859375 71.820312 C 36.179688 71.101562 40.589844 70.738281 45 70.738281 C 49.410156 70.738281 53.820312 71.101562 58.140625 71.820312 C 62.460938 72.539062 66.78125 73.621094 70.921875 75.058594 C 71.550781 73.53125 72.089844 72.089844 72.628906 70.648438 C 54.808594 64.53125 35.191406 64.53125 17.371094 70.648438 C 17.910156 72.089844 18.449219 73.53125 19.078125 75.058594 Z M 19.078125 75.058594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinceCrown);
export default __webpack_public_path__ + "static/media/prince-crown.fb0d4aded52f898ffe842060f14572af.svg";
export { ForwardRef as ReactComponent };